import {
  Receipt,
  ReceiptAuthorityCommunicationState,
  ReceiptFiscalOperation,
  ReceiptSaleDocumentState,
  ReceiptStatus,
} from './receipts.service';

function fiscalOperationOf(receipt: Receipt): ReceiptFiscalOperation {
  return receipt.fiscalOperation ?? ReceiptFiscalOperation.RECEIPT;
}

function saleStateOf(receipt: Receipt): ReceiptSaleDocumentState {
  return receipt.saleDocumentState ?? ReceiptSaleDocumentState.NONE;
}

function receiptRowIsFailed(r: Receipt): boolean {
  return (
    r.status === ReceiptStatus.FAILED ||
    r.authorityCommunicationState === ReceiptAuthorityCommunicationState.FAILED
  );
}

/**
 * Active commercial (vendita) document that should block force-create until voided / fully returned.
 * CANCELLATION and CORRECTION rows never block; VOIDED / FULL_RETURN vendita do not block.
 */
export function isBlockingCommercialReceipt(receipt: Receipt): boolean {
  if (fiscalOperationOf(receipt) !== ReceiptFiscalOperation.RECEIPT) {
    return false;
  }
  const sale = saleStateOf(receipt);
  if (sale === ReceiptSaleDocumentState.VOIDED || sale === ReceiptSaleDocumentState.FULL_RETURN) {
    return false;
  }
  if (receiptRowIsFailed(receipt)) {
    return false;
  }
  return true;
}

/** True when at least one receipt prevents issuing another commercial document via force-create. */
export function shouldBlockForceCreateReceipt(receipts: Receipt[] | null | undefined): boolean {
  if (!receipts?.length) {
    return false;
  }
  return receipts.some(isBlockingCommercialReceipt);
}

/**
 * Status value for sync menus: truthy when disabled (existing commercial doc), null when enabled.
 * Avoids treating an empty array as disabled (`!![]` is true in ExternalSyncButton).
 */
export function forceCreateReceiptMenuStatus(receipts: Receipt[] | null | undefined): Receipt[] | null {
  return shouldBlockForceCreateReceipt(receipts) ? receipts! : null;
}
